import { generateConfig } from 'config'
import { sleeper } from 'utils'
import { rejectResponseAbove } from './utils'

export function acceptInvite(
  organizationId,
  inviteToken,
  { username, displayName, password, photoURL }
) {
  const abFlagsIds = generateConfig().abFlags

  return fetch(`/api/auth/invites/${inviteToken}/accept`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      data: {
        type: 'users',
        attributes: {
          organizationId,
          username,
          displayName,
          password,
          photoURL,
          abFlagsIds,
        },
      },
    }),
  })
    .then(rejectResponseAbove(400))
    .then((response) => response.json())
    .then(sleeper(1000))
    .then(({ data, included }) => {
      const user = data.attributes
      const authTokens = included.find(
        ({ type }) => type === 'authTokens'
      ).attributes

      return {
        user,
        authTokens,
      }
    })
}
